const CustomError = (props) => {
    return <div className="error">{props.error}</div>;
}


export default CustomError;